<script setup>
import { get } from "../helpers/api";
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import { computed, onMounted, ref } from "vue";
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

const dashboardStatics = ref({
  invoice_count: 0,
  today_invoice_count: 0,
  vehicle_number_count: 0,
  today_vehicle_number_count: 0,
  invoices_total: 0,
  today_invoices_total: 0,
  latest_invoices: [],
  monthly_invoice_totals: [] 
});

const getDashboardStatics = async () => {
  try {
    const response = await get("/get-company-statics", null);
    if (response.data.status === 'success') {
      const data = response.data.data;
      dashboardStatics.value = { ...dashboardStatics.value, ...data };
    }
    console.log(response);
  } catch (error) {
    console.log(error);
  }
};

const invoicesDescription = computed(() => {
  const count = dashboardStatics.value.today_invoice_count;
  return `<span class='text-sm font-weight-bolder text-success'>${count}</span> Today`;
});

const vehicleDescription = computed(() => {
  const count = dashboardStatics.value.today_vehicle_number_count;
  return `<span class='text-sm font-weight-bolder text-success'>${count}</span> Today`;
});

const invoiceTotalDescription = computed(() => {
  const count = dashboardStatics.value.today_invoices_total;
  return `<span class='text-sm font-weight-bolder text-success'>${count}</span> Today`;
});

const plotChart = () => {
  const ctx = document.getElementById("invoicesChart").getContext("2d");

  if (!dashboardStatics.value.monthly_invoice_totals.length) {
    console.log("No data available for chart.");
    return;
  }

  // Create a list of all months
  const allMonths = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  // Prepare data with default values of 0
  const data = allMonths.map(month => {
    const entry = dashboardStatics.value.monthly_invoice_totals.find(item => item.month === month);
    return {
      month: month,
      total: entry ? entry.total : 0
    };
  });

  new Chart(ctx, {
    type: 'bar',
    data: {
      labels: data.map(item => item.month),
      datasets: [{
        label: 'Total Invoices',
        data: data.map(item => item.total),
        backgroundColor: 'rgba(75, 192, 192, 0.8)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1
      }]
    },
    options: {
      scales: {
        y: {
          beginAtZero: true
        }
      }
    }
  });
};


onMounted(async () => {
  await getDashboardStatics();
  plotChart();
});

</script>

<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-12">
            <mini-statistics-card
              title="Invoices"
              :value="dashboardStatics.invoice_count"
              :description="invoicesDescription"
              :icon="{
                component: 'ni ni-single-copy-04',
                background: 'bg-gradient-primary',
                shape: 'rounded-circle',
              }"
            />
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <mini-statistics-card
              title="Vehicles"
              :value="dashboardStatics.vehicle_number_count"
              :description="vehicleDescription"
              :icon="{
                component: 'fa fa-car',
                background: 'bg-gradient-success',
                shape: 'rounded-circle',
              }"
            />
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <mini-statistics-card
              title="Invoices Total" 
              :value="'Rs. ' + dashboardStatics.invoices_total.toLocaleString()"
              :description="'Rs. ' + invoiceTotalDescription.toLocaleString()"
              :icon="{
                component: 'ni ni-money-coins',
                background: 'bg-gradient-danger',
                shape: 'rounded-circle',
              }"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <div class="card mt-4">
              <div class="card-header pb-0 p-3">
                <h6 class="mb-0">Latest Invoices</h6>
              </div>
              <div class="card-body p-3">
                <ul class="list-group">
                  <li v-for="invoice in dashboardStatics.latest_invoices" :key="invoice.id" class="list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg">
                    <div class="d-flex align-items-center">
                      <div class="icon icon-shape icon-sm me-3 bg-gradient-primary shadow text-center">
                        <i class="ni ni-single-copy-04 text-white"></i>
                      </div>
                      <div class="d-flex flex-column">
                        <h6 class="mb-1 text-dark text-sm">
                          <a :href="`http://127.0.0.1:8000/view-invoice/${invoice.uuid}`" class="text-dark" target="_blank">
                            {{ invoice.invoice_number }}
                          </a>
                        </h6>
                        <span class="font-weight-bold">Total: Rs. {{ invoice.sub_total }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
              <div class="card mt-4">
                  <div class="card-header pb-0 p-3">
                      <h6 class="mb-0">Monthly Invoice Summary </h6>
                  </div>
                  <div class="card-body p-3">
                      <canvas style="width:100%; height: 380px;" id="invoicesChart"></canvas>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
